import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

const Tool = {
  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  },
  formatTime(_date, type) {
    const date = new Date(_date)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return type == 'date'
      ? [year, month, day].map(this.formatNumber).join('-')
      : [year, month, day].map(this.formatNumber).join('-') +
      ' ' +
      [hour, minute, second].map(this.formatNumber).join(':')
  },
  formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  },
  exportExcel(tHeader, filterVal, list, name) {
    require.ensure([], () => {
      const {export_json_to_excel} = require('./Export2Excel')
      const data = this.formatJson(filterVal, list)
      export_json_to_excel(tHeader, data, name)
    })
  },
  exportExcelElTable(excelName, ref) {
    try {
      console.log(this.$refs)
      const $e = ref.$el
      // 如果表格加了fixed属性，则导出的文件会生产两份一样的数据，所以可在这里判断一下
      let $table = $e.querySelector('.el-table__fixed')
      if (!$table) {
        $table = $e
      }
      // 为了返回单元格原始字符串，设置{ raw: true }
      const wb = XLSX.utils.table_to_book($table, {raw: true})
      const wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
      FileSaver.saveAs(
        new Blob([wbout], {type: 'application/octet-stream'}),
        `${excelName}.xlsx`
      )
    } catch (e) {
      if (typeof console !== 'undefined') console.error(e)
    }
  },
  computedAttr(attrs, obj) {
    let total = 0
    const attrArr = attrs.split('+')
    attrArr.forEach(e => {
      if (obj[e]) {
        total += obj[e] - 0
      }
    })
    return total
  },
  calcuateMoney(money) {
    return (money && money > 0) ? Math.floor(money * 100) / 100 : 0
  },
  formateData(attrArr, obj) {
    attrArr.forEach(e => {
      obj[e.key] = this.computedAttr(e.attrs, obj.result)
    })
  },
  findIndexInArryByKeyVal(arr, key, val) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][key] == val) {
        return i
      }
    }
    return -1
  },
  isNumber(val) {
    return !!val && !isNaN(val)
  },
  formatMoney(s, isFixed) {
    if (/[^0-9\.]/.test(s)) return '0'
    if (s == null || s == '') return '0'
    s = s.toString().replace(/^(\d*)$/, '$1.')
    s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
    s = s.replace('.', ',')
    var re = /(\d)(\d{3},)/
    while (re.test(s)) {s = s.replace(re, '$1,$2')}
    s = s.replace(/,(\d\d)$/, '.$1')
    if (!isFixed) { // 不带小数位(默认是有小数位)
      var a = s.split('.')
      if (a[1] == '00') {
        s = a[0]
      }
    }
    return s
  },
  frontMove(arr, index) {
    if (index < 1) return arr
    arr[index] = arr.splice(index - 1, 1, arr[index])[0]
    return arr
  },
  backMove(arr, index) {
    if (index >= arr.length - 1) return arr
    arr[index] = arr.splice(index + 1, 1, arr[index])[0]
    return arr
  },
  nowTime() { // 获取当前时间
    const date = new Date()
    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    const hours = ('0' + date.getHours()).slice(-2)
    const minutes = ('0' + date.getMinutes()).slice(-2)
    const seconds = ('0' + date.getSeconds()).slice(-2)
    const formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    return formattedDate
  },
  /**
 * 生成指定长度的随机字符串，必须同时包含
 * 大写字母、小写字母、数字、特殊符号各至少一个
 * @param {number} len 目标长度（必须 >= 4）
 * @returns {string}
 * @throws {Error}
 */
  strongRandomString(len = 12) {
    if (len < 4) throw new Error('Length must be >= 4 to satisfy all character classes');

    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const digits = '0123456789';
    // const special = '!@#$%^&*()-_=+[]{}<>~`.?,;:|';
    const special = '';

    // 随机取指定池子里的 1 个字符
    const pick = pool => pool[rand(pool.length)];

    // 基于 crypto.getRandomValues 的随机整数 [0, max)
    const rand = max => {
      const rng = new Uint32Array(1);
      crypto.getRandomValues(rng);
      return rng[0] % max;
    };

    // 1. 每类先抽 1 个
    const arr = [
      pick(upper),
      pick(lower),
      pick(digits),
      // pick(special)
    ];

    // 2. 剩余长度
    const pool = upper + lower + digits + special;
    for (let i = 4; i < len; i++) arr.push(pick(pool));

    // 3. Fisher–Yates 打乱
    for (let i = arr.length - 1; i > 0; i--) {
      const j = rand(i + 1);
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr.join('');
  }

}

export default Tool
